<template>
  <div id="products">
    <div v-if="product === 'overview'">
      The industry-leading tradition of Euro Precast Concrete originated more than 50 years ago in Denmark at our
      parent company, Give Elementer, a leading supplier of precast concrete components for commercial, industrial,
      agricultural and residential applications.
    </div>
    <div v-else>
      <component :is="product"></component>
    </div>
  </div>
</template>

<script>
  import RetainingWalls from '@/components/products/RetainingWalls'
  import FreeStandingWalls from '@/components/products/FreeStandingWalls'
  import BuildingWallPanels from '@/components/products/BuildingWallPanels'
  import Columns from '@/components/products/Columns'
  import ArchitecturalElements from '@/components/products/ArchitecturalElements'
  import Enclosures from '@/components/products/Enclosures'

  export default {
    name: 'Products',
    props: ['product'],
    components: {
      RetainingWalls,
      FreeStandingWalls,
      BuildingWallPanels,
      Columns,
      ArchitecturalElements,
      Enclosures
    },
    data() {
      return {
        products: [
          'retaining-walls',
          'free-standing-walls',
          'building-wall-panels',
          'columns',
          'architectural-elements',
          'enclosures'
        ]
      }
    },
  }
</script>

<style scoped>
</style>